import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";

const MaintenanceAccounts = (props) => {

    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <div>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={8}>
                            <TitlePage title="Administración \ Cuentas y Bóvedas"/>
                        </Grid>
                        <Grid item xs={4} style={{textAlign: 'right'}}>
                            <Button type="button" iconPos="left" label="Buscar"
                                    style={{marginRight: '.5em'}} onClick={props.getDataAccounts}/>
                        </Grid>
                        <Grid item xs={12}> <Divider/> </Grid>
                        <Grid item xs={12}>
                            <div style={{textAlign: 'right'}}>
                                <Button type="button" iconPos="left" label="Agregar"
                                        style={{marginRight: '.5em'}}
                                        className="p-button-secondary"
                                        onClick={props.redirectAddAccount}/>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="content-section implementation">
                                <DataTable value={props.dataMaintAccounts}
                                           responsive={true}
                                           selectionMode="single"
                                           onSelectionChange={props.handleSelectAccount}
                                           resizableColumns={true}
                                           columnResizeMode={"fit"}>
                                    <Column field="cuenta" header="Cuenta" style={{textAlign: 'right'}}
                                            sortable={true}/>
                                    <Column field="cuentaValorGSS" header="Cuenta GSS" style={{textAlign: 'right'}}
                                            sortable={true}/>
                                    <Column field="descrCuenta" header="Descripción" style={{textAlign: 'left'}}
                                            sortable={true}/>
                                    <Column field="idInst" header="Id. Inst." style={{textAlign: 'right'}}
                                            sortable={true}/>
                                    <Column field="folioInst" header="Folio Inst." style={{textAlign: 'right'}}
                                            sortable={true}/>
                                    <Column field="boveda" header="Bóveda" style={{textAlign: 'right'}}
                                            sortable={true}/>
                                    <Column field="cuentaEfectivo" header="Cuenta Efectivo" style={{textAlign: 'right'}}
                                            sortable={true}/>
                                    <Column field="nombreCorto" header="Nombre Bóveda" style={{textAlign: 'left'}}
                                            sortable={true}/>
                                    <Column header="Acciones" body={props.maintAccountsOrderActionTemplate}
                                            style={{textAlign: 'center', width: '8em'}}/>
                                </DataTable>
                                {props.confirmationMsg}
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(MaintenanceAccounts);
